
import Icon from '@/components/Icon.vue'
import Switch from '@/modules/membership/signal/components/Switch.vue'
import TheLimitRangeInput from '@/modules/trade/components/TheLimitRangeInput.vue'
import Order from '@/modules/trade/Order'
import { useOrderLimit } from '@/modules/trade/trade'
import Pic from '@/components/Pic.vue'
import { computed, defineComponent, inject, shallowRef, unref } from 'vue'
import RealTimeQuote from '@/provider/RealtimeQuote.vue'
import { add } from 'essential/tools/math'
import { TradeDirection } from '@/types'

export default defineComponent({
  name: 'TheStopLoss',
  components: {
    RealTimeQuote,
    Pic,
    Icon,
    TheLimitRangeInput,
    Switch,
  },
  props: {
    showDistance: Boolean,
    symbol: Object,
    isCommission: Boolean,
    createPrice: String,
  },
  setup () {
    const order = inject('order') as Order
    const showExplain = shallowRef(false)

    const { pips, limit, profit, estQuote, distance, minPips, maxPips } = useOrderLimit(unref(order.stopLoss.value), -1)
    const noLimit = computed(() => pips.value === 0)
    const toggleLimit = (state: boolean) => {
      limit(state ? Number(maxPips.value) : 0)
    }

    return {
      showExplain,
      minPips,
      maxPips,
      pips,
      order,
      noLimit,
      profit,
      estQuote,
      distance,
      limit,
      toggleLimit,
      calcProfitLossPrice (v1: number, v2: string) {
        const v2Arr = v2.split('.')
        let fixedNum = 0
        if (v2Arr.length > 1) {
          fixedNum = v2Arr[1].length
        }
        return add(v1 * (Number(order.type.value) === TradeDirection.SELL ? -1 : 1), v2).toFixed(fixedNum)
      },
      exceed () {
        // showAlert(translate('toast_16'))
      },
    }
  },
})
